import React from 'react';
import {
  Table, TableHead, TableBody, TableRow, TableCell,
  TextField, Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useLocalizedMessage } from 'util/useLocalizedMessage';

const SWATCH_SIZE = 24;

const useStyles = makeStyles({
  count: {
    color: '#868e96',
    fontSize: '0.85rem',
  },
  colorCell: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  swatch: {
    width: SWATCH_SIZE,
    height: SWATCH_SIZE,
    borderRadius: 4,
    border: '1px solid #dee2e6',
    flexShrink: 0,
  },
  hexInput: {
    width: 120,
  },
});

const HEX_PATTERN = /^#[0-9a-fA-F]{6}$/;

const ColorMappingEditor = ({ values, onUpdateMapping }) => {
  const classes = useStyles();
  const localizeMessage = useLocalizedMessage();

  const handleChange = (rawValue) => (e) => {
    const val = e.target.value.trim();
    onUpdateMapping(rawValue, val || null);
  };

  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell>{localizeMessage('customization.filters.valueEditor.rawValue')}</TableCell>
          <TableCell align="right">{localizeMessage('customization.filters.valueEditor.productCount')}</TableCell>
          <TableCell>{localizeMessage('customization.filters.valueEditor.mapping')}</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {values.map((v) => {
          const isValid = v.mappedValue && HEX_PATTERN.test(v.mappedValue);
          return (
            <TableRow key={v.rawValue}>
              <TableCell>
                <Typography variant="body2">{v.rawValue}</Typography>
              </TableCell>
              <TableCell align="right">
                <Typography variant="body2" className={classes.count}>{v.productCount}</Typography>
              </TableCell>
              <TableCell>
                <div className={classes.colorCell}>
                  <div
                    className={classes.swatch}
                    style={{ backgroundColor: isValid ? v.mappedValue : '#ffffff' }}
                  />
                  <TextField
                    className={classes.hexInput}
                    variant="outlined"
                    margin="dense"
                    size="small"
                    placeholder={localizeMessage('customization.filters.valueEditor.hexPlaceholder')}
                    value={v.mappedValue || ''}
                    onChange={handleChange(v.rawValue)}
                    error={Boolean(v.mappedValue && !isValid)}
                  />
                </div>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};

export default ColorMappingEditor;
